import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-950">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-20">
        <div className="w-full max-w-2xl text-center">
          <p className="font-label text-7xl tracking-[0.2em] text-background-700 md:text-9xl">404</p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
            这一页还没排进片单
          </h1>
          <p className="mt-3 text-sm leading-7 text-foreground-400">
            你访问的地址是 <span className="text-secondary-300">{location.pathname}</span>
            ，可能已经调整或从未存在。回到首页，或者从电影与短视频分类继续找片。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-background-950 transition-colors hover:bg-accent-400 sm:w-auto"
            >
              <i className="ri-home-4-line text-base" />
              返回首页
            </Link>
            <Link
              to="/movies"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-700 px-5 py-3 text-sm text-foreground-100 transition-colors hover:border-accent-500/60 hover:text-accent-400 sm:w-auto"
            >
              浏览电影分类
            </Link>
            <Link
              to="/short-videos"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-700 px-5 py-3 text-sm text-foreground-100 transition-colors hover:border-accent-500/60 hover:text-accent-400 sm:w-auto"
            >
              浏览短视频
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}